import moment from "moment";
import { useEffect, useState } from "react";

function AutoTime() {
  const [date, setDate] = useState(new Date());
  useEffect(() => {
    setInterval(() => {
      setDate(new Date());
    }, 1000);
  }, []);
  return (
    <span className="date">{moment(date).format("YYYY/MM/DD HH:mm:ss")}</span>
  );
}

export default AutoTime;
